import { Box, Link, Stack, Typography, useMediaQuery } from '@mui/material'
import { TProductSocialMedia } from '../../../../core/types/Product'
import { ArrowRightAltRounded, Instagram, Telegram } from '@mui/icons-material'

interface ISocialMediaChoose {
  onChange: (value: TProductSocialMedia) => void
}

const items = [
  {
    type: TProductSocialMedia.Telegram,
    label: 'Telegram',
    description: 'Grupo ou canal privado',
    icon: <Telegram sx={{ fontSize: '92px' }} />,
    disabled: false,
  },
  {
    type: TProductSocialMedia.Instagram,
    label: 'Instagram',
    description: 'Closed friends ou conta privada',
    icon: (
      <Instagram sx={{ fontSize: '92px', color: 'rgba(220, 221, 222, 1)' }} />
    ),
    disabled: true,
  },
]

const SocialMediaChooseMobile = ({ onChange }: ISocialMediaChoose) => (
  <Stack direction="column" spacing={2} sx={{ gap: '16px' }}>
    {items.map(({ type, label, description, icon, disabled }) => (
      <Link
        key={type}
        onClick={() => (disabled ? undefined : onChange(type))}
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid rgba(220, 221, 222, 1)',
          borderRadius: '8px',
          width: '100%',
          padding: '16px',
          textDecoration: 'none',
        }}
      >
        {icon}
        <Box sx={{ ml: 2 }}>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 700,
              fontSize: '16px',
              lineHeight: '20px',
              color: 'rgba(52, 57, 72, 1)',
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '18px',
              color: 'rgba(52, 57, 72, 1)',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Link>
    ))}
  </Stack>
)

const SocialMediaChoose = ({ onChange }: ISocialMediaChoose) => {
  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('md')
  )

  if (isSmallScreen) {
    return <SocialMediaChooseMobile onChange={onChange} />
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: 'center',
        height: '286px',
        gap: '16px',
      }}
    >
      {items.map(({ type, label, description, icon, disabled }) => (
        <Link
          key={type}
          onClick={() => (disabled ? undefined : onChange(type))}
          sx={{
            border: '1px solid rgba(220, 221, 222, 1)',
            borderRadius: '8px',
            width: '240px',
            height: '286px',
            padding: '24px',
            gap: '32px',
            textDecoration: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            alignContent="center"
            alignItems="center"
            sx={{ p: 2 }}
          >
            <Box sx={{ p: 1 }}>{icon}</Box>

            <Typography
              sx={{
                fontFamily: 'Montserrat',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '20px',
                color: disabled
                  ? 'rgba(220, 221, 222, 1)'
                  : 'rgba(52, 57, 72, 1)',
              }}
            >
              {label}
            </Typography>
            <Typography
              align="center"
              sx={{
                fontFamily: 'Montserrat',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '18px',
                color: disabled
                  ? 'rgba(220, 221, 222, 1)'
                  : 'rgba(52, 57, 72, 1)',
              }}
            >
              {description}
            </Typography>
            <ArrowRightAltRounded
              sx={{
                fontSize: '32px',
                color: disabled ? 'rgba(220, 221, 222, 1)' : undefined,
              }}
            />
          </Stack>
        </Link>
      ))}
    </Stack>
  )
}

export default SocialMediaChoose
